import { jsxs as k, jsx as u } from "react/jsx-runtime";
import { useState as b, useRef as d, useCallback as g, useEffect as h } from "react";
import { Icon as D } from "../../../../components/Icon/index.js";
import { CommentAvatar as $ } from "../CommentAvatar/index.js";
import { useCommentInputEditor as F } from "./hooks/useCommentInputEditor.js";
import { CommentInputTextArea as tt } from "./components/CommentTextArea/index.js";
import { CommentInputContainer as et, CommentInputContent as ot, CommentSubmitButtonContainer as nt, CommentSubmitButton as rt, IconCommentSuggestion as ut } from "./style.js";
import { SubmitAction as v, CommentAction as E } from "../../types.js";
import { isSubmittableValue as mt } from "./services/isSubmittableValue/index.js";
import { CommentSuggestionsCarousel as lt } from "../../CommentSuggestionsCarousel/index.js";
import { useTranslation as at } from "../../../../hooks/useTranslation/index.js";
import { PaperPlaneTop as it, PaperPlaneTopSolid as M } from "@pelando/fontawesome/icons";
import { TextCapsulesizeType as ct } from "../../../../components/TextCapsule/types.js";
function xt({
  defaultValue: I = "",
  disabled: T,
  className: N,
  id: c,
  parentId: y,
  isEdit: o,
  isReply: l,
  isLoading: _,
  isFocused: s,
  author: j,
  authorImage: q,
  goToProfile: z,
  uploadHandler: w,
  dispatch: n,
  commentsuggestions: a,
  onClickSuggestion: x,
  hideImageUploadButton: K = !1
}) {
  const { t: m } = at("common"), [S, O] = b(I), [V, Y] = b(!0), [B, H] = b(!1), [e, A] = b(), L = mt(S), i = d(void 0), C = d(void 0), p = d(null), U = a && a.length > 0 && V, W = m(T ? "comment-input-blocked-placeholder" : o ? "comment-input-edit-placeholder" : l ? "comment-input-answer-placeholder" : "comment-input-comment-placeholder"), P = g(
    (t) => {
      var r;
      if (l && c) {
        n({
          type: v.REPLY,
          payload: { id: c, parentId: y, value: t }
        });
        return;
      }
      if (o && c) {
        n({
          type: v.EDIT,
          payload: { id: c, value: t }
        });
        return;
      }
      !o && i.current && ((r = i.current) == null || r.deleteText(0, i.current.getLength(), "api")), A(void 0), H(!0), n({ type: v.NEW_COMMENT, payload: { value: t } });
    },
    [l, c, o, n, y]
  ), G = g(() => {
    o && n({ type: E.CANCEL_EDIT, payload: void 0 }), l && n({ type: E.CANCEL_REPLY, payload: void 0 });
  }, [o, l, n]), { quill: f, quillRef: J } = F({
    defaultValue: I,
    placeholder: W,
    disabled: T,
    onEscKeydown: G,
    onHotkeySubmit: () => P(S),
    onChange: O,
    imageHandlerUpload: w
  });
  h(() => {
    i.current = f, i.current && !o && i.current.setText((e == null ? void 0 : e.text) || "");
  }, [e == null ? void 0 : e.text, o, f]), h(() => {
    C.current = f, s && C.current && C.current.focus();
  }, [s, C, f]);
  const Q = (t) => a == null ? void 0 : a.find(
    (Z) => Z.id === t
  );
  h(() => {
    s && setTimeout(() => {
      var t;
      (t = p == null ? void 0 : p.current) == null || t.scrollIntoView({
        behavior: "smooth",
        block: "end"
      });
    }, 100);
  }, []);
  const R = (t) => {
    const r = Q(t);
    A(r), x && x(r == null ? void 0 : r.id);
  }, X = () => L ? e ? /* @__PURE__ */ u(
    ut,
    {
      icon: it,
      "aria-label": m("comment-input-submit-button-aria-label")
    }
  ) : /* @__PURE__ */ u(
    D,
    {
      icon: M,
      "aria-label": m("comment-input-submit-button-aria-label")
    }
  ) : /* @__PURE__ */ u(
    D,
    {
      icon: M,
      "aria-label": m("comment-input-submit-button-aria-label")
    }
  );
  return /* @__PURE__ */ k(et, { children: [
    U && /* @__PURE__ */ u(
      lt,
      {
        suggestions: a,
        onClickSuggestion: R,
        selectedSuggestionId: e == null ? void 0 : e.id,
        capsuleSize: ct.SMALL
      }
    ),
    /* @__PURE__ */ k(ot, { className: N, children: [
      /* @__PURE__ */ u(
        $,
        {
          author: j,
          authorImage: q,
          goToProfile: z
        }
      ),
      /* @__PURE__ */ u(
        tt,
        {
          isReply: l,
          dispatch: n,
          uploadHandler: w,
          quill: f,
          quillRef: J,
          isLoading: _,
          hideImageUploadButton: K,
          submitButtonRef: p,
          onSetFocused: (t) => {
            Y(!t);
          },
          submitted: B
        }
      ),
      /* @__PURE__ */ u(nt, { ref: p, children: /* @__PURE__ */ u(
        rt,
        {
          type: "button",
          onClick: () => {
            P(S);
          },
          onMouseDown: (t) => {
            t.preventDefault(), t.stopPropagation();
          },
          disabled: !L,
          children: X()
        }
      ) })
    ] })
  ] });
}
export {
  xt as CommentInput
};
